import { render, staticRenderFns } from "./loginPage.vue?vue&type=template&id=a295c774&scoped=true&"
import script from "./loginPage.vue?vue&type=script&lang=js&"
export * from "./loginPage.vue?vue&type=script&lang=js&"
import style0 from "./loginPage.vue?vue&type=style&index=0&id=a295c774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a295c774",
  null
  
)

export default component.exports